import React from "react";
import Table from "../../layout/table.jsx";
import API from "../../../services/api.jsx";
import moment from "moment";
import { debounce } from "lodash";
import Loader from "../../layout/loader.jsx";
import Helpers from "../../../services/helpers.jsx";

class CollectionsList extends React.Component {
  constructor(props) {
    super(props);
    let that = this;

    const columns = [
      {
        label: 'Collection name',
        key: 'name',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Playlists',
        key: 'playlists',
        view: (field) => {
          if (!field) return '-';
          return field.length;
        },
      },
      {
        label: 'Usage',
        key: 'linkedCampaigns',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Created',
        key: 'createdAt',
        view: function (field) {
          return moment(field).format('l');
        },
      },
      {
        label: 'Updated',
        key: 'updatedAt',
        view: function (field) {
          return moment(field).format('l');
        },
      },
    ];
    if (Helpers.checkPermissions("collections:delete")) {
      columns.push({
        action: "delete",
      });
    }

    const actions = [];
    if (Helpers.checkPermissions("collections:edit")) {
      actions.push({
        classList: "blue add",
        label: "New collection",
        onClick: () => this.props.history.push("/assets/collections/new"),
      });
    }

    this.state = {
      loading: true,
      filters: {},
      sort: ["name", "ASC"],
      collections: {
        columns,
        entities: [],
        filters: [
          {
            label: "Search for a collection",
            onChange: debounce((value) => {
              if (value !== this.state.filters.name)
                this.setState(
                  {
                    filters: {
                      ...this.state.filters,
                      name: value ? "/" + value + "/i" : "",
                    },
                  },
                  () => {
                    this.loadEntities();
                  }
                );
            }, 500),
          },
        ],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (
            Helpers.checkPermissions(
              ["collections:details", "collections:edit"],
              true
            )
          ) {
            this.props.history.push(
              `/clients/${this.props.match.params.clientId}/collections/${entity.id}`
            );
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  loadEntities() {
    API.getClientCollections(
      this.props.match.params.clientId,
      this.state.filters,
      this.state.sort
    ).then((entities) => {
      const filters = [];
      if (entities?.filters?.availableFilters) {
        Helpers.handleFilters(this, filters, entities);
      }

      this.setState({
        ...this.state,
        collections: {
          ...this.state.collections,
          filters,
          entities: entities?.data || [],
        },
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return <Table settings={this.state.collections} sort={this.state.sort} />;
  }
}

export default CollectionsList;
